import * as React from 'react'
import { useParams } from 'react-router-dom'

import { observer } from 'mobx-react'

import UpsertLeaveType from 'modules/timeoff/components/LeaveTypeSettings/LeaveTypes/UpsertLeaveType'

const EditLeaveTypePage = () => {
  const { id } = useParams()

  return <UpsertLeaveType leaveTypeId={id} />
}

export default observer(EditLeaveTypePage)
